import { render } from "./BulkShiftModal.vue?vue&type=template&id=48f853b2"
import script from "./BulkShiftModal.vue?vue&type=script&lang=js"
export * from "./BulkShiftModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__